import variableColors from "@/base/global/variables/figma.colors.json";

export const spinThemeToken: any = {
  colorBgMask: variableColors["ColorFigmaNeutralWhiteWhite100"],
  indicatorSize: "40px",
  indicatorSizeSm: "24px",
  indicatorSizeLg: "80px",
};
